import React from 'react'
import ReactDOM from 'react-dom/client'
import ReactGA from 'react-ga4'
import AppRouter from './routes/route'
import './css/main.css'
import './css/tailwind.css'
import { SnackBarProvider } from './providers/snack_bar_provider'
import { LoadingProvider } from './providers/loading_provider'
import { UnreadNotificationsProvider } from './providers/unread_notifications_provider'
import { BrowserRouter } from 'react-router-dom'
import { RecoilRoot } from 'recoil'

ReactGA.initialize(process.env.REACT_APP_GA_TAG_ID ?? 'TEST-TOKEN', {
  testMode: process.env.REACT_APP_ENV !== 'production',
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
document.documentElement.setAttribute('lang', 'ja')

root.render(
  <RecoilRoot>
    <LoadingProvider>
      <SnackBarProvider>
        <UnreadNotificationsProvider>
          <BrowserRouter>
            <React.StrictMode>
              <AppRouter />
            </React.StrictMode>
          </BrowserRouter>
        </UnreadNotificationsProvider>
      </SnackBarProvider>
    </LoadingProvider>
  </RecoilRoot>
)
